import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { TelegramMessengerService } from '@src/app/modules/telegram';

import { SubscriptionsForUsersService } from './subscriptions-for-users.service';
import { ChatsService } from './chats.service';
import { SubscriptionsForUsersCommitteeService } from './subscriptions-for-users-committee.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class BadgeService {
  private readonly messengerService = inject(TelegramMessengerService);
  private readonly subscriptionsForUsersService = inject(SubscriptionsForUsersService);
  private readonly subscriptionsForUsersCommitteeService = inject(SubscriptionsForUsersCommitteeService);
  private readonly chatsService = inject(ChatsService);
  private readonly userService = inject(UserService);

  chats$ = new BehaviorSubject<number | null>(null);
  events$ = new BehaviorSubject<number | null>(null);
  polls$ = new BehaviorSubject<number | null>(null);
  channels$ = new BehaviorSubject<number | null>(null);
  chatsIds: number[] = [];
  channelsIds: number[] = [];
  unreadChatsIds: number[] = [];

  private organisationsSubChatsIds$ = this.subscriptionsForUsersService.subscriptionsChatIds$;
  private committeesSubChatsIds$ = this.subscriptionsForUsersCommitteeService.subscriptionsChatIds$;
  private unionsChatsIds$ = this.chatsService.chatsIds$;
  private unionsUsersTelegramIds$ = this.userService.usersTelegramIds$;
  private subChats?: Subscription;
  private subUsers?: Subscription;

  constructor() {
    this.messengerService.allChatsIds$.subscribe(allChatIds => {
      if (!allChatIds.length) return;

      // TODO: refactoring. hack for first loading
      this.subChats = this.unionsChatsIds$.subscribe(() => {
        this.setBadgeChats();
        this.subChats?.unsubscribe();
      });
      this.subUsers = this.unionsUsersTelegramIds$.subscribe(() => {
        this.setBadgeChats();
        this.subUsers?.unsubscribe();
      });
      // TODO END

      this.chatsService.getChats(allChatIds);
      this.userService.getUsersTelegramIds(allChatIds);
    });

    this.subscriptionsForUsersService.subscriptionsChatIds();
    this.subscriptionsForUsersCommitteeService.subscriptionsChatIds();

    this.messengerService.updates$.subscribe(update => {
      switch (update._) {
        case 'updateChatReadInbox':
          this.setBadge(update.chatId, update.unreadCount);
          break;

        default:
          break;
      }
    });
  }

  private setBadge(chatId: number, count: number): void {
    if (!this.unreadChatsIds.includes(chatId) && count) {
      this.unreadChatsIds.push(chatId);
    }
    if (this.unreadChatsIds.includes(chatId) && !count) {
      this.unreadChatsIds.splice(
        this.unreadChatsIds.findIndex(id => id === chatId),
        1,
      );
    }

    if (this.organisationsSubChatsIds$.value.includes(chatId) || this.committeesSubChatsIds$.value.includes(chatId)) {
      const unreadCount = this.getUnreadCount(this.organisationsSubChatsIds$.value, this.committeesSubChatsIds$.value);
      this.channels$.next(unreadCount);
    } else if (this.unionsChatsIds$.value.includes(chatId) || this.unionsUsersTelegramIds$.value.includes(chatId)) {
      this.setBadgeChats();
    }
  }

  private getUnreadCount(ids1: number[], ids2: number[] = []): number {
    const ids = [...new Set(ids1.concat(ids2))];
    return ids.filter(id => this.unreadChatsIds.includes(id)).length;
  }

  private setBadgeChats() {
    const unreadCount = this.getUnreadCount(this.unionsChatsIds$.value, this.unionsUsersTelegramIds$.value);
    this.chats$.next(unreadCount);
  }
}
